var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForky(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84 168C130.392 168 168 130.392 168 84C168 37.6081 130.392 0 84 0C37.6081 0 0 37.6081 0 84C0 130.392 37.6081 168 84 168ZM96.4573 44.7174C102.66 47.041 104.249 54.95 104.249 81.7318C104.249 88.933 102.967 95.4565 99.9594 100.271L98.841 103.195L92.2407 120.432L97.9697 159.773C97.9697 162.35 92.4878 164.747 89.9104 164.747H85.6671C83.0898 164.747 77.6079 162.574 77.6079 160V121.898C75.7984 118.172 73.7285 113.762 71.8089 109.609C70.5636 106.921 69.3884 104.354 68.4002 102.184C65.3087 98.1941 64 92.4151 64 85.1237C64 58.352 64.01 48.8805 70.2097 45.5487L70.9275 79.2713C70.9275 80.9706 72.1527 82.3528 73.6584 82.3528H74.6232C76.1289 82.3528 77.3508 80.9706 77.3475 79.4048L80.1619 43.7959C81.3905 43.7659 82.7025 43.7559 84.1247 43.7559C84.5436 43.7559 84.9512 43.755 85.3506 43.7542C85.7343 43.7533 86.1104 43.7525 86.4817 43.7525L89.2995 79.2746C89.2995 80.9739 90.5247 82.3561 92.0304 82.3561H92.9952C94.5009 82.3561 95.7262 80.9739 95.7262 79.3113L96.4573 44.7174Z",
    fill: "#E12653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForky);
export default __webpack_public_path__ + "static/media/forky.32423fd16c2152d059741dd281cdae1a.svg";
export { ForwardRef as ReactComponent };